import React from 'react';
import { any, isNil } from 'ramda';

import { Container } from './noData.styles';

export const isNoData = (...props) => any(isNil)(props);

export const NoData = ({ width, height }) => (
  <Container width={width} height={height}>
    No Data
  </Container>
);
